import React from "react";
import Footer from "../components/Footer";
import "./PlanningPage.css"; // Reuse same styles

const ExteriorPage: React.FC = () => {
  return (
    <div className="planning-page">
      {/* Hero Section */}
      <section className="planning-hero">
        <div className="hero-content">
          <h1>Exterior Design Planning</h1>
          <p>
            Where structure meets landscape — harmonizing buildings with their surroundings.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="planning-content">
        <div className="content-box">
          <h2>Planning the Environment</h2>
          <p>
            The natural environment is at once a hindrance and a help, and the architect seeks both to invite its aid and to repel its attacks. To make buildings habitable and comfortable, he must control the effects of heat, cold, light, air, moisture, and dryness and foresee destructive potentialities such as fire, earthquake, flood, and disease.
          </p>
          <p>
            The methods of controlling the environment considered here are only the practical aspects of planning. They are treated by the architect within the context of the expressive aspects. The placement and form of buildings in relation to their sites, the distribution of spaces within buildings, and other planning devices discussed below are fundamental elements in the aesthetics of architecture.
          </p>

          <h2>Orientation</h2>
          <p>
            The arrangement of the axes of buildings and their parts is a device for controlling the effects of sun, wind, and rainfall. The sun is regular in its course; it favours the southern and neglects the northern exposures of buildings in the Northern Hemisphere, so that it may be captured for heat or evaded for coolness by turning the axis of a plan toward or away from it.
          </p>
          <p>
            Within buildings, the axis and placement of each space determines the amount of sun it receives. Orientation may control air for circulation and reduce the disadvantages of wind, rain, and snow, since in most climates the prevailing currents can be foreseen. The characteristics of the immediate environment also influence orientation: trees, land formations, and other buildings create shade and reduce or intensify wind, while bodies of water produce moisture and reflect the sun.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ExteriorPage;
